let timers = {}
let requestIds = {}
const MAX_STORED_IDS = 50

const cleanupOldEntries = () => {
	const entries = Object.keys(requestIds)
	if (entries.length > MAX_STORED_IDS) {
		entries.slice(0, entries.length - MAX_STORED_IDS).forEach(key => {
			delete requestIds[key]
			delete timers[key]
		})
	}
}

export const debounce = (milliseconds, fn, id) => {
	clearTimeout(timers[id])
	const currentId = (requestIds[id] = (requestIds[id] || 0) + 1)
	const isCurrent = () => requestIds[id] === currentId
	timers[id] = setTimeout(() => {
		fn(isCurrent)
		cleanupOldEntries()
	}, milliseconds)
}

export default debounce
